import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, formatApiError } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { AuthShell, GoogleButton } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const [searchParams] = useSearchParams();
  const [form, setForm] = useState({
    name: "",
    email: searchParams.get("email") || "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error("Senha precisa ter pelo menos 6 caracteres"); return; }
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Conta criada! Bem-vindo ao Monyxx.");
      navigate(searchParams.get("redirect") || "/app");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Criar conta"
      subtitle="Comece grátis em 30 segundos"
      footer={<>Já tem conta? <Link to="/login" className="text-emerald-300 hover:underline">Entrar</Link></>}
    >
      <GoogleButton label="Cadastrar com Google" />
      <div className="my-5 flex items-center gap-3 text-xs text-slate-500">
        <div className="flex-1 h-px bg-slate-800" /> ou com e-mail <div className="flex-1 h-px bg-slate-800" />
      </div>
      <form onSubmit={submit} className="space-y-3">
        <Input type="text" required placeholder="Seu nome" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
        <Input type="email" required placeholder="seu@email.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
        <Input type="password" required placeholder="Senha (mín. 6 caracteres)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
        <Button type="submit" disabled={loading} className="w-full h-11 monyx-btn-primary text-white rounded-full font-semibold" data-testid="register-submit">
          {loading ? "Criando..." : "Criar conta grátis"}
        </Button>
      </form>
    </AuthShell>
  );
}
